import React from 'react';
import { format } from 'date-fns';
import ptBR from 'date-fns/locale/pt-BR';

export function ExportacaoDados({ modalData }) {
  return (
    <div>
      <div>
        <span>CNES</span>
        <p>{modalData && modalData.cnes}</p>
      </div>

      <div>
        <span>E-mail do responsável</span>
        <p>{modalData && modalData.email}</p>
      </div>

      <div>
        <span>Data e hora do evento</span>
        <p>
          {(modalData &&
            format(
              new Date(`${modalData.dataCriacao}`),
              'dd/MM/yyyy - HH:mm:ss',
              {
                locale: ptBR,
              }
            )) ||
            ''}{' '}
        </p>
      </div>

      <div>
        <span>Linha de Cuidado</span>
        <p>{modalData && modalData.nomeLinhaCuidado}</p>
      </div>

      <div>
        <span>Período</span>
        <p>{modalData && modalData.periodo}</p>
      </div>
    </div>
  );
}
